const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/certificates.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
interface Certificate {
  id: string;
  certificateNumber: string;
  certificateType: string;
  title: string;
  petName: string;
  petId: string | null;
  businessName?: string;
  ownerName: string | null;
  bookingId: string | null;
  issuedByName: string | null;
  issuedByTitle: string | null;
  issuedByLicenseNo: string | null;
  signatureImageUrl: string | null;
  signerName: string | null;
  signedAt: string | null;
  issuedAt: string;
  validFrom: string | null;
  validUntil: string | null;
  status: 'issued' | 'revoked';
  revokedAt: string | null;
  revokedReason: string | null;
  documentHash: string | null;
  data: Record<string, unknown> | null;
  remarks: string | null;
  createdAt: string;
}
export const Route = createFileRoute('/dashboard/certificates')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});